export const ROLLING_RESERVE_HISTORY_STATUS_ENUM = {
    AWAIT: 'await', // удержаны с клиента
    HOLD: 'hold', // клиент или его клиент накосяпорл и мы забрали часть его резерва
    RETURN: 'return', // средства возвращены
};
